import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,
    message
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '档案修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
class PagePurRecord extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const level = params.get("level");
        let source = '';
        switch (level){
            case "1":
                source = "管理员"
                break;
            case "2":
                source = "业务员"
                break;
            case "3":
                source = "司机"
                break;
        }
        this.state = {
            title: "账号管理",
            source: source,
            county: [],
            id: id,
            level: level,
            list: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
            .then(res => res.json())
            .then(
                (result) => {
                    let options = [];
                    let array = result.data;
                    for (let i = 0; i < array.length; i++) {
                        let l = {
                            value: array[i].id,
                            label: array[i].name
                        }
                        options.push(l)
                        array[i].id = i + 1
                    }
                    this.setState({
                        isLoaded: true,
                        menulist: array,
                        options: options
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        var id = this.state.id
        if(id) {
            fetch("https://pd.pokemonbye.com:8084/api/getsellclientwxbyid?id=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data[0];
                        this.setState({
                            isLoaded: true,
                            list: array
                        });
                        this.formRef.current.setFieldsValue(array)

                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            console.log(value)
            this.setState({
                client: value
            });
        };
        const onFinish = (values) => {
            console.log(this.state.list)
            var list = {};
            list.name = values.name ? values.name : this.state.list.name;
            list.clientid = this.state.client ? this.state.client : this.state.list.clientid;
            list.tel = values.tel ? values.tel : this.state.list.tel;
            list.pubtime = values.pubtime ? values.pubtime : this.state.list.pubtime;
            list.level = this.state.level ? this.state.level : this.state.list.lid;
            list.time = moment().format('YYYY-MM-DD HH:mm:ss') ;

            var id = this.state.id
            if(this.state.id){
                fetch("https://pd.pokemonbye.com:8084/api/setsellclientwxbyid?&client="+list.clientid+"&level="+list.level+"&name="+list.name+"&tel="+list.tel+"&id="+id)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            let array = result.data[0];
                            this.setState({
                                isLoaded: true,
                                list: array
                            });
                            openNotification();

                            setTimeout(window.location.href="/pagepurrecords",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }else{
                fetch("https://pd.pokemonbye.com:8084/api/insertsellclientwx?&client="+list.clientid+"&level="+list.level+"&state=1"+"&pubtime="+list.time+"&name="+list.name+"&tel="+list.tel)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            let array = result.data[0];
                            this.setState({
                                isLoaded: true,
                                list: array
                            });
                            openNotification();

                            setTimeout(window.location.href="/pagepurrecords",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Title level={5}>新增{this.state.source}</Title>
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 10,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                >
                                    <Form.Item label="账号">
                                        <Input disabled={false} bordered={false} placeholder={this.state.list.num}/>
                                    </Form.Item>
                                    <Form.Item label="用户名称" name="name">
                                        <Input placeholder={this.state.list.name}/>
                                    </Form.Item>
                                    <Form.Item label="联系方式" name="tel">
                                        <Input placeholder={this.state.list.tel}/>
                                    </Form.Item>
                                    <Form.Item label="所属企业" name="cname">
                                        <Select
                                            defaultValue={this.state.list.cname}
                                            style={{
                                                width: 220,
                                            }}
                                            options={this.state.options}
                                            onChange={handleChange}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">{this.state.id?'提交修改':'新建'}</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PagePurRecord;


